import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
	FeaturedPostgraduate,
	FeaturedUndergraduate,
	Product,
} from '@uc/web/shared/data-models';
import { VisitWebsiteBtnComponent } from '@web/shared/ui';

@Component({
	selector: 'uc-application-deadline',
	templateUrl: './application-deadline.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgClass, DatePipe, VisitWebsiteBtnComponent],
})
export class ApplicationDeadlineComponent {
	applicationDeadline = input.required<string>();
	externalUrl = input.required<string | undefined>();
	isFeatured = input.required<FeaturedUndergraduate | FeaturedPostgraduate>();
	uniId = input.required<number>();
	uniName = input.required<string>();
	product = input.required<Product>();
	courseName = input.required<string>();
	ugSearchOrderPosition = input.required<number | null>();
}
